import React from "react";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { Hooks, Context, Cookie } from "@xt/xtbase";
import styles from "./index.module.scss";
import store from "@/store";

const { useTranslation } = Hooks;
const { XtContext } = Context;

const CHECK_SVG = (
  <svg className={styles["settings-option-check"]} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CURRENCY_LIST = [
  { key: "usd", name: "USD" },
  { key: "krw", name: "KRW" },
  { key: "inr", name: "INR" },
  { key: "idr", name: "IDR" },
  { key: "cny", name: "CNY" },
];

const SettingCurrency: React.FC = () => {
  const t = useTranslation();
  const router = useRouter();
  const [, appDispatch] = React.useContext(XtContext);
  const currency = (typeof window !== "undefined" ? Cookie.get("currency") : null) ?? "usd";

  const handleSelect = (obj: { key: string; name: string }) => {
    if (obj.key === currency) return;
    Cookie.set("currency", obj.key);
    appDispatch?.({ payload: { currency: obj.key } });
    store.currency.updateAssist(obj.key);
    router.back();
  };

  return (
    <div className={styles["settings-select-page"]}>
      <div className={styles["settings-option-list"]}>
        {CURRENCY_LIST.map((item) => (
          <div
            key={item.key}
            role="button"
            tabIndex={0}
            className={styles["settings-option-item"]}
            onClick={() => handleSelect(item)}
            onKeyDown={(e) => e.key === "Enter" && handleSelect(item)}
          >
            <span className={styles["settings-option-label"]}>{item.name}</span>
            {currency === item.key ? CHECK_SVG : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default observer(SettingCurrency);
